"use strict";
/**
 * Shared type and resolver for strings that may vary per language.
 *
 * `LocalizedString` is either a plain string (applies to every language) or a
 * map keyed by ISO locale. Callers use it for any string-shaped configuration
 * where partners running across multiple language domains want a different
 * value per language — community guidelines / privacy / terms URLs, public
 * notification URLs, sender display names, etc. Domain-specific types stay in
 * their own modules and compose `LocalizedString` for each field that needs
 * the per-language treatment.
 *
 * `resolveLocalizedString` mirrors the dialect → primary subtag → en-US
 * fallback used by the server's email-template `getLanguageMap`, so any
 * surface reading a `LocalizedString` resolves the same way.
 *
 * Lives in `packages/shared` so it can be imported from both the React/Expo
 * client and the Firebase Functions server without runtime-specific deps.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLocalizedString = resolveLocalizedString;
const locale_1 = require("./locale");
/**
 * Resolve a `LocalizedString` value for a specific language. Tries dialect →
 * primary subtag default → en-US, then returns undefined so the caller can
 * apply its own domain-level default.
 */
function resolveLocalizedString(value, language) {
    if (value === undefined)
        return undefined;
    if (typeof value === 'string')
        return value;
    const dialectMatch = value[language];
    if (dialectMatch)
        return dialectMatch;
    const baseLocale = (0, locale_1.expandPrimarySubtag)(language.split('-')[0].toLowerCase());
    const baseMatch = baseLocale ? value[baseLocale] : undefined;
    if (baseMatch)
        return baseMatch;
    return value['en-US'];
}
//# sourceMappingURL=localized-string.js.map